import { useApplicationModals } from "app/common/hooks";
import { ModalMolecule } from "app/components/molecules/modal";
import { Button, OutlineButton } from "app/components/atoms/button";

/**
 * Konfirmasi "Terima" barang di halaman Penerimaan.
 *
 * Menggantikan `window.confirm(...)` yang dipakai sebelumnya: dialog native
 * memblokir seluruh event browser, sehingga otomatisasi (Playwright,
 * Claude in Chrome) membeku begitu tombol Terima diklik, dan tampilannya
 * tidak bisa diberi data-testid. Isi pesannya sama persis.
 *
 * Payload (`receiveOrderItem.confirm`): { id, qty, old_qty, label }.
 * `onSuccess(id, qty, old_qty)` dipanggil hanya saat "Ya".
 */
function ConfirmReceiveOrderItem({ onSuccess = () => {} }) {
  const { showStates, getPayloads, closeModal } = useApplicationModals();
  const payload = getPayloads("receiveOrderItem.confirm") || {};

  const handleClose = () => closeModal("receiveOrderItem.confirm");
  const handleYes = () => {
    closeModal("receiveOrderItem.confirm");
    onSuccess(payload.id, payload.qty, payload.old_qty);
  };

  return (
    <ModalMolecule
      show={showStates["receiveOrderItem.confirm"]}
      title="Konfirmasi Penerimaan Barang"
      onClose={handleClose}
    >
      <div>
        <p data-testid="modal-confirm-receive-order-item-message">
          Apakah Anda yakin menerima barang ini? {payload.label} sebanyak{" "}
          <span className="font-semibold">{payload.qty} pcs</span>
        </p>
        <div className="mt-6 flex justify-end gap-2">
          <OutlineButton
            testId="modal-confirm-receive-order-item-batal-button"
            type="button"
            onClick={handleClose}
          >
            Batal
          </OutlineButton>
          <Button
            testId="modal-confirm-receive-order-item-ya-button"
            type="button"
            onClick={handleYes}
          >
            Ya, Terima
          </Button>
        </div>
      </div>
    </ModalMolecule>
  );
}

export default ConfirmReceiveOrderItem;
